import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  getAllTeleconsultations,
  updateTeleconsultation,
} from 'api/teleconsultations';
import { getAllDoctors } from 'api/doctors';
import { updateCustomer } from 'api/customers';
import { runUpdater } from 'updaters/teleconsultation';
import { FIRST_TELE_COLUMNS } from 'config/teleconsultation';
import { filtersToQueryString, initialFilters } from 'helpers/filtering';
import { setDoctorOptions } from 'helpers/doctor';
import MainViewWithTable from 'components/main_view_with_table';
import TeleconsultationButtons from 'components/teleconsultation_buttons';

const FirstTeleconsultationsPage = ({ onCountUpdate, onMessages }) => {
  const [meta, setMeta] = useState({});
  const [fetching, setFetching] = useState(true);
  const [allTeles, setAllTeles] = useState([]);
  const [columns, setColumns] = useState(FIRST_TELE_COLUMNS);

  const fetchData = async (page, filters = {}, search) => {
    filters['stage'] = ['first'];
    const filtersString = filtersToQueryString(filters, search);
    const data = await getAllTeleconsultations(page, filtersString);

    setAllTeles([...data.items]);
    setMeta(data.meta);
    setFetching(false);
  };

  useEffect(() => {
    (async () => {
      const allDoctors = await getAllDoctors();
      const newColumns = setDoctorOptions({
        columns: FIRST_TELE_COLUMNS,
        data: allDoctors,
      });

      const initFilters = initialFilters(FIRST_TELE_COLUMNS);
      await fetchData(1, initFilters);

      setFetching(false);
      setColumns(newColumns);
    })();
  }, []);

  const handleSelect = async (prop, value, c) => {
    const index = allTeles.findIndex((t) => t.id === c.id);
    const { id } = allTeles.find((t) => t.id === c.id);

    const newTeles = await runUpdater(allTeles, c, columns, prop, value, index);

    const {
      teleconsultation,
      meta: { messages },
    } = await updateTeleconsultation(id, {
      ...c,
      [prop]: value,
    });

    newTeles[index] = teleconsultation;

    setAllTeles([...newTeles]);
    onCountUpdate();
    onMessages(messages);
  };

  const handleTextUpdate = async (value, c) => {
    const index = allTeles.findIndex((t) => t.id === c.id);

    const newCustomer = await updateCustomer(c.customer.id, {
      notes: value,
    });
    allTeles[index].customer = newCustomer;

    setAllTeles([...allTeles]);
    onCountUpdate();
  };

  const props = {
    data: allTeles,
    columns,
    fetchData,
    fetching,
    meta,
    onSelect: handleSelect,
    onTextUpdate: handleTextUpdate,
    title: 'First teleconsultations',
    accessor: 'teleconsultations',
  };

  return (
    <MainViewWithTable {...props}>
      <TeleconsultationButtons />
    </MainViewWithTable>
  );
};

FirstTeleconsultationsPage.propTypes = {
  onCountUpdate: PropTypes.func.isRequired,
  onMessages: PropTypes.func.isRequired,
};

export default FirstTeleconsultationsPage;
